import React, { forwardRef, useEffect, useState } from 'react'
import { CustomModal } from '@components'
import { Typography } from '@mui/material';

const InfoModal = forwardRef(({ handleClose, startTime, endTime, lunchStart, lunchEnd }, ref) => {
    // timer
    const [timer, setTimer] = useState(25);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer(timer => timer - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        if (timer === 0) {
            handleClose();
        }
    }, [timer, handleClose]);

    useEffect(() => {
        if (ref.current) {
            setTimer(25);
        }
    }, [ref]);

    const handleSubmit = () => {
        handleClose();
    }

    startTime = startTime?.replace('.', ':');
    endTime = endTime?.replace('.', ':');
    lunchStart = lunchStart?.replace('.', ':');
    lunchEnd = lunchEnd?.replace('.', ':');

    return (
        <CustomModal
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            timer={timer}
            modalTitle={`Info`}
            modalTitleColor={'#EB6969'}
            buttonText={'Ok'}
            ref={ref}
            className='modal-button-danger'
        >
            <Typography variant="body1" color={'#000'}>
                You can only trade between {startTime} and {endTime} and lunch break is between {lunchStart} and {lunchEnd}. Please come back later.
            </Typography>
        </CustomModal>
    )
})

export default InfoModal